import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import {
  IPublicSuburbanV1GetOffersHistoryRequest,
  IMappers,
} from '../../../../repositories/valuation-offer-history/suburban/v1/get-offers-history';
import { IOffersHistoryListingData } from '../../../../types/offerHistory';
import { prepareOffersHistory } from '../../mappers';
import { EDealType } from '../../../../types/dealType';

export const createSuburbanOffersHistoryListingMapper = (
  parameters: IPublicSuburbanV1GetOffersHistoryRequest,
): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => prepareOffersHistory(response, EDealType.Sale),
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: 'fetchSuburbanOffersHistoryListing.ts',
      statusCode: 400,
      message: message || /* istanbul ignore next */ '',
      details: { ...parameters },
    });
  },
});

export type TMappedResponse200 = IOffersHistoryListingData;
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TMappedResponse = TMappedResponse200 | TMappedResponse400;
